import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { hideActiveOverlay } from 'Store/Overlay/Overlay.action';

import SearchPopup from './SearchPopup.component';

/** @namespace PeggysagePwa/Component/SearchPopup/Container/mapStateToProps */
export const mapStateToProps = (_state) => ({});

/** @namespace PeggysagePwa/Component/SearchPopup/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    hideActiveOverlay: () => dispatch(hideActiveOverlay())
});

/** @namespace PeggysagePwa/Component/SearchPopup/Container */
export class SearchPopupContainer extends PureComponent {
    static propTypes = {
        payload: PropTypes.shape({
            title: PropTypes.string
        }),
        hideActiveOverlay: PropTypes.func.isRequired
    };

    static defaultProps = {
        payload: {
            title: ''
        }
    };

    state = {
        searchCriteria: ''
    };

    containerFunctions = {
        onSearchBarFocus: this.onSearchBarFocus.bind(this),
        onSearchBarChange: this.onSearchBarChange.bind(this),
        onClearSearchButtonClick: this.onClearSearchButtonClick.bind(this),
        onSearchOutsideClick: this.onSearchOutsideClick.bind(this)
    };

    onSearchBarFocus() {
        // ...
    }

    onSearchBarChange({ target: { value: searchCriteria } }) {
        this.setState({ searchCriteria });
    }

    onClearSearchButtonClick() {
        this.setState({ searchCriteria: '' });
    }

    onSearchOutsideClick() {
        const { hideActiveOverlay } = this.props;

        hideActiveOverlay();
    }

    containerProps() {
        const { payload, hideActiveOverlay } = this.props;
        const { searchCriteria } = this.state;

        return {
            payload,
            hideActiveOverlay,
            searchCriteria
        };
    }

    render() {
        return (
            <SearchPopup
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchPopupContainer);
